import React from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { BsCheckCircle } from "react-icons/bs";
import { ReactComponent as CrossIcon } from "../../../../../assets/utils/images/svgs/Cross.svg";
import { useGebruikerContext } from "../../Context/GebruikerContext";

const Rollen = () => {
	const { userDetails } = useGebruikerContext();
	const data = userDetails?.profileList;

	return (
		<>
			<Card className="main-card">
				<CardBody>
					<Row>
						<Col className=" col-12">
							<h5 className="mb-4">Rollen</h5>
							<Row className="mb-4 mt-1 d-flex justify-content-between align-items-center">
								<Col className="col-md-6 mt-0">Vervanger</Col>
								<Col className="col-md-6 mt-0">
									{data?.isSubstitutor ? (
										<BsCheckCircle color="#39A825" fontSize="18px" />
									) : (
										<CrossIcon />
									)}
								</Col>
							</Row>
							<Row className="mb-4 mt-1 d-flex justify-content-between align-items-center">
								<Col className="col-md-6 mt-0">Melder</Col>
								<Col className="col-md-6 mt-0">
									{data?.isRequestor ? (
										<BsCheckCircle color="#39A825" fontSize="18px" />
									) : (
										<CrossIcon />
									)}
								</Col>
							</Row>
							<Row className="mb-4 mt-1 d-flex justify-content-between align-items-center">
								<Col className="col-md-6 mt-0">Coordinator</Col>
								<Col className="col-md-6 mt-0">
									{data?.isCoordinator ? (
										<BsCheckCircle color="#39A825" fontSize="18px" />
									) : (
										<CrossIcon />
									)}
								</Col>
							</Row>
						</Col>
					</Row>
				</CardBody>
			</Card>
		</>
	);
};

export default Rollen;
